<template>

    <main id="main" class="ms-sm-auto">

        <div class="container">
            <div class="iframe-report" v-if="show_iframe">
                <img @click="closeIframe" class="lesson-action-button" src="/themes/ito/images/close-iframe.svg" alt="">
                <iframe class="iframe-report-item" width="100%" height="100%" :src="src_report" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="card card-parents">
                <div class="card-header">
                    <div class="card-title">{{$t('academic_report')}}</div>
                </div>
                <div class="card-body">
                    <div class="card-content cert">
                        <div v-if="is_academic != -1">
                            <template v-for="(acd, index) in academics">
                                <div class="row">
                                    <template v-for="(item, index) in acd.class_term">
                                        <div class="col-md-4">
                                            <div class="item-academic">
                                                <img src="/themes/ito/images/preview.svg"/>
                                                <div class="item-academic-class">{{acd.class_name}}</div>
                                                <div class="item-academic-name">{{item.term_name}}</div>
                                                <div class="btn-preview"
                                                     @click="reviewAcademic(acd.class_id,item.term_id)">
                                                    {{$t('preview')}}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                        <div v-else>
                            <p class="desc_certificates">{{$t('empty_academic_report')}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="card" v-for="(grade_book, index) in grade_books">
                <input type="checkbox" id="card-basic-info" class="card-input" checked/>

                <label class="card-header-label" for="card-basic-info">
                    <div class="card-title">Semester {{index + 1}}</div>
                    <div class="card-tools hide">
                        <a class="academic-report-link" href="#" @click.prevent="showGradeBookLink(grade_book)" v-if="grade_book.academic_report">Academic report</a>
                    </div>
                </label>

                <div class="card-body hide">
                    <div class="grade-book-content">
                        <div class="grade-book-inner">
                            <div class="grade-book-items">
                                <div class="d-flex justify-content-between">
                                    <div class="left-grade-item">&lt;Program - Subject&gt;</div>
                                    <div class="right-grade-item">&lt;Point&gt;</div>
                                </div>
                            </div>
                            <div class="grade-book-items" v-for="(subject, index) in grade_book.subject">
                                <div class="d-flex justify-content-between">
                                    <div class="left-grade-item text-capitalize">{{subject.program_code + " " + subject.subject_code}}</div>
                                    <div class="right-grade-item">{{subject.point}}</div>
                                </div>
                                <div v-if="subject.skill" class="grade-item-skills">
                                    <div class="row">
                                        <div class="col-md-6 gi-skill-item" v-for="(skill, index) in subject.skill">
                                            <div class="grade-item-skill-item d-flex">
                                                <div class="flex text-capitalize">{{skill.skill_code}}</div>
                                                <div class="text-right">{{skill.value}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                            <div class="grade-book-items" style="background-color: #FFC061;">
                                <div class="d-flex justify-content-between">
                                    <div class="left-grade-item">Overal Result</div>
                                    <div class="right-grade-item">{{grade_book.overal_result}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

        </div>

        <div id = "gradebook-read-content" v-if="!is_page_list && grade_book_selected">
            <img class="gradebook-read-close" src="/themes/web/assets/images/greadbook-close.svg" @click="closeReadGreadbook">         
            <div class="container">
                <div style="height: 100vh;">
                    <iframe width="100%" height="100%" :src="grade_book_selected.academic_report" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </main>

</template>

<script>
import axios from "axios";
import {getParentReport, getCertificateReport, getAcademicReport, getEbookReport} from "../../models/parent";
import { getGradeBooks } from '../../models/grade_book';

export default {
    name: "Assignment",
    title: "Assignment",

    data() {
        const user_info = this.$store.state.user_info;

        let child_account = localStorage.getItem('child_account');

        child_account = child_account?JSON.parse(child_account):null;

        if(child_account == null && user_info.childrens){
            child_account = user_info.childrens[0];
        }

        return {
            grade_books: [],
            grade_book_selected: null,
            child_account: child_account,
            is_page_list: true,
            academics: [],
            src_report: '',
            show_iframe: false,
            is_academic: false,
            eco_url: process.env.VUE_APP_ECO_URL
        };
    },

    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
    },

    created() {
        this.$store.commit("setMenuActive", "grade_book");

       this.fetch();
    },

    methods: {
        fetch() {
            const {lesson_id} = this.$route.params;

            this.lesson_id = lesson_id;

            this.getGradeBooks();
            this.getAcademic();
        },
        closeIframe(){
            this.show_iframe = false;
        },
        reviewAcademic(classId, termId) {
            let eco_user_id = localStorage.getItem('child_account') ? JSON.parse(localStorage.getItem('child_account')).eco_user_id : '';
            let url = this.eco_url + '/api_eco.php/get_ar?class_id=' + classId + '&eco_id=' + eco_user_id + '&class_term=' + termId;
            this.redirect_blank(url);

            // this.show_iframe = true;
            this.src_report = url
        },
        redirect_blank(url) {
            var a = document.createElement('a');
            a.target = "_blank";
            a.href = url;
            a.click();
        },
        getAcademic(){
            const that = this;
            that.$store.commit("setLoading", true);
            const formData = new FormData();
            formData.append('eco_user_id', localStorage.getItem('child_account') ? JSON.parse(localStorage.getItem('child_account')).eco_user_id : '');
            getAcademicReport(formData).then((data) => {
                that.$store.commit("setLoading", false);
                if (data.status == 200) {
                    that.academics = data.data.data;
                    this.is_academic = that.academics.findIndex(x => {
                        return x.class_term.length > 0
                    })
                }
            }).catch(({response}) => {
                that.$store.commit("setLoading", false);
                alert(response.data.results);
            });
        },

        showGradeBookLink(grade_book){
            this.grade_book_selected = grade_book;
            this.is_page_list = false;
        },

        closeReadGreadbook(){
            this.is_page_list = true;
        },

        async getGradeBooks() {
            const that = this;

            that.isLoading = true;

            await axios.all([
                getGradeBooks({
                    user_id: that.child_account.id
                }),
            ]).then(axios.spread((response) => {
                that.isLoading = false;

                if (response.data.code != 0) {
                    return;
                }

                that.grade_books = response.data.results.semester || [];

                console.log(that.grade_books);
                
                // that.grade_books = [
                //     {
                //         academic_report: true,
                //         overal_result: 5,
                //         subject: [
                //             {
                //                 program_code: "English",
                //                 point: 10,
                //                 skill: [
                //                     {
                //                         skill_code: "Speaking",
                //                         value: 8.25
                //                     },
                //                     {
                //                         skill_code: "Listening",
                //                         value: 7.5
                //                     },
                //                     {
                //                         skill_code: "Reading",
                //                         value: 8.25
                //                     },
                //                     {
                //                         skill_code: "Writing",
                //                         value: 7.5
                //                     },
                //                 ]
                //             },
                //             {
                //                 program_code: "ISMART Science",
                //                 point: 9,
                //                 skill: [
                //                     {
                //                         skill_code: "4 Skill",
                //                         value: 12
                //                     }
                //                 ]
                //             }
                //         ]
                //     },
                // ]
            }));
        },        
    },
};
</script>

<style scoped>
 .item-academic-class {
        font-family: Nunito;
        font-size: 14px;
        font-weight: 700;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: center;
        margin-top: 10px;
        color: #1B1B1B;
    }
    .item-academic-name {
        font-family: Nunito;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: center;
        color: #1B1B1B;
    }
    .btn-preview {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #00A3FF;
        border-radius: 8px;
        padding: 8px 20px 8px 20px;
        color: #fff;
        cursor: pointer;
        width: fit-content;
        align-self: center;
        margin-top: 5px;
    }
    .item-academic {
        display: flex;
        text-align: center;
        flex-direction: column;
        justify-content: center;
        padding:20px 40px;
        margin: 0 !important;
    }
    .desc_certificates{
        color: #1B1B1B;
        font-weight: 700;
        font-size: 16px;
        text-align: center;
        margin: 0;
        padding: 30px 0;
    }

    .iframe-report{
        position: absolute;

        z-index: 99999;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }
    .iframe-report img{
        position: absolute;
        right: 50px;
        top: 90px;
        z-index: 99999;
        cursor: pointer;
    }
</style>
